import * as React from 'react';
import { useSelector } from "react-redux";
import ProductCompareClearAll from "../ProductCompareClearAll";
import ProductCompare from "@system/config/product-compare";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";

const BottomCompareActions = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const data = useSelector((state) => state.entities.model_ProductCompare.data);
    return (
        <>

            <div className="col-12 col-md-auto p-0 align-self-center">
                {__check(['PRODUCT_COMPARE_API_CALL', { inline: true }]).render}
                {!__check(['PRODUCT_COMPARE_API_CALL']).status &&
                    <div className="compare-actions">
                        <ProductCompareClearAll />
                        <a className={"bs5 btn btn-primary " + (Object.entries(data).length <= 1 ? 'disabled' : '')} href={ProductCompare.getProductComparePageRouteURL()}>COMPARE
                            ({Object.entries(data).length}/10)</a>
                    </div>
                }
            </div>

        </>
    );
}

export default BottomCompareActions;